<!-- @name:用户绑定手机&QQ号  @description:买1赠N活动-购买支持直充能力  @author:zhilichao -->
<template>
    <div 
        class="bind-account-popup-warp" 
        @touchmove.prevent.stop>
        <section class="content-warp">
            <header class="header">
                <h5>{{ titleText }}</h5>
            </header>
            <div class="middle-warp">
                <!-- 绑定手机号 -->
                <div 
                    v-if="type == 1 || type == 3 || type == 4"
                    class="bind-phone">
                    <p 
                        v-if="type == 3"
                        class="label-name">手机号</p>
                    <div class="phone input-warp">
                        <input 
                            v-model="valObj.tel.val"
                            type="tel" 
                            placeholder="请输入手机号"
                            @click="onFocus($event)"
                            @focus="onFocus($event)"
                            @blur="onBlur">
                    </div>
                    <div class="captcha-code input-warp">
                        <input 
                            v-model="valObj.verifyCode.val"
                            type="tel" 
                            placeholder="请输入验证码"
                            @click="onFocus($event)"
                            @focus="onFocus($event)"
                            @blur="onBlur">
                        <button
                            :class="`${!isClickBtn ? 'disabled' : ''}`"
                            @click="clickCodeBtn">
                            {{ isClickBtn ? '获取验证码' : `已发送(${isClickTimes})` }}
                        </button>    
                    </div>
                </div>

                <!-- 绑定qq号 -->
                <div 
                    v-if="type == 2 || type == 3 || type == 5"
                    class="bind-qq bind-qq-pd">
                    <p 
                        v-if="type == 3"
                        class="label-name">QQ号</p>
                    <div class="qq input-warp">
                        <input 
                            v-model="valObj.qq.val"
                            type="tel" 
                            placeholder="请输入QQ号"
                            @click="onFocus($event)"
                            @focus="onFocus($event)"
                            @blur="onBlur">
                    </div>
                    <div 
                        v-if="type != 3" 
                        class="qq input-warp">
                        <input 
                            v-model="valObj.qq.confirmVal"
                            type="tel" 
                            placeholder="请再次输入QQ号"
                            @click="onFocus($event)"
                            @focus="onFocus($event)"
                            @blur="onBlur">
                    </div>
                </div>

                <!-- 确认账号 -->
                <div 
                    v-if="type == 6 || type == 7 || type==8"
                    class="confirm-account">
                    <!-- 绑定的手机号 -->
                    <div 
                        v-if="type == 6 || type == 7"
                        :class="`account-phone account-warp ${type==6 ? 'account-phone-pd' :''}`">
                        <div class="text">
                            <span>手机号：</span>{{ userBindAccount.phone_account || "" }}
                        </div>
                        <button @click="changePhone">变更></button>
                    </div>
                    <!-- 绑定的QQ号 -->
                    <div 
                        v-if="type == 7 || type==8" 
                        class="account-qq account-warp">
                        <div class="text">
                            <span>QQ号：</span>{{ userBindAccount.qq_account || "" }}
                        </div>
                        <button @click="changeQQ">变更></button>
                    </div>
                </div>
                <div 
                    v-if="type==1 || type==4"
                    class="tips-text-warp">
                    注：联合会员需通过手机号才能充值
                </div>
                <div 
                    v-if="type==2 || type==5"
                    class="tips-text-warp">
                    注：联合会员需通过QQ号才能充值
                </div>
                <div 
                    v-if="type==3"
                    class="tips-text-warp">
                    注：联合会员需通过手机号/QQ号才能充值
                </div>
                <div 
                    v-if="(type==6 || type==7 || type==8) && confirmTips" 
                    class="tips-text-warp tips-text-warp-pd"
                    @click="clickTipsText($event)"
                    v-html="confirmTips"/>
                <div class="submit-warp">
                    <button @click="clickConfirmBtn">{{ btnText }}</button>
                </div>
            </div>

            <!-- 弹窗底部关闭按钮 -->
            <footer class="footer">
                <button 
                    class="close-btn"
                    @click="clickCloseBtn"
                />
            </footer>
        </section>
    </div>
</template>

<script>
// 极验sdk
import "@/pages/native/authornew/contribute/js/geetest.js";
import xss from "@kkmh/xss";
import { tools } from "@/assets/js/SDK_copy/libs/sdk.tools";
import { 
    switch_page, 
    /** show_tips **/
} from "@kk/h5-sdk";
import { 
    // getVerifyConfig, // 获取腾讯云滑动验证配置
    // postSmsSendCode,  // 发送验证码
    postBindAccount, // 绑定通用联合会员账号
    getAccount // 查询绑定的通用联合会员账号
} from "../api/verify.api.js";
import { getGeetestInit, postCheckGt, postGetSMSCodeGeetest } from "@/api/pay/link_vip_multiple.api.js";
import gs from "@kk/gs";
const Console = console;
export default {
    name: "BindAccountPopup",

    props: {
        // 父级传递的用户绑定信息
        userData: {
            type: null,
            default() {
                return {};
            }
        },
        // 确认账号-提示文案
        tispText:{
            type: String,
            default: ""
        }
    },

    data() {
        return {
            // 1: 绑定手机号 2: 绑定qq号 3.绑定手机和QQ号 4:变更账号(手机号) 5:变更账号(QQ号) 6:确认账号(手机) 7:确认账号(qq/手机号)
            type: -1, 
            tCaptchaConfig: null, // 滑动验证码的配置
            isClickBtn: true, // 是否可以点击发送验证码按钮
            isClickTimes: 0, // 下次获取验证的时间(单位S)
            ticket: "", // 腾讯滑动验证码返回的校验通过码 - 腾讯验证码参数
            random: "", // 腾讯滑动验证码返回的特殊标识 - 腾讯验证码参数
            isClickConfirmBtn: true, // 是否可以点击确认(确认购买)按钮
            valObj:{
                tel:{
                    reg: /^1[3-9]\d{9}$/, //手机号
                    val: ""
                },
                qq:{
                    reg: /^\d{5,10}$/, // QQ号
                    val: "",
                    confirmVal: "" // QQ二次确认输入
                },
                verifyCode:{
                    isClick: false,
                    reg: /^\d{6}$/, // 验证校验,
                    val: ""
                }
            },
            userBindAccount: {}, // 用户绑定的账号信息
            reg: /(^ +| +$)/g, //过滤空格
            countDownTime: null, // 倒计时组件计时器
            captchaObj: null // 极验验证码配置
        };
    },

    computed: {
        // 设置弹窗标题文案和提交按钮文案
        titleText() {
            // 1: 绑定手机号 2: 绑定qq号 3.绑定手机和QQ号 4:变更账号(手机号) 5:变更账号(QQ号) 6:确认账号(手机) 7:确认账号(qq/手机号)
            let title = "";
            const type = this.type;
            if(type == 1 || type == 2 || type == 3) {
                title = "绑定账号";
            } else if(type==4 || type==5) {
                title = "变更账号";
            } else if(type==6 || type==7 || type==8){
                title = "确认账号";
            }
            return title;   
        },

        btnText() {
            let text = "确认";
            const type = this.type;
            if(type == 1 || type == 2 || type == 3) {
                text = "确认绑定";
            } else if(type==4 || type==5) {
                text = "确认变更";
            } else if(type==6 || type==7 || type==8){
                text = "确认并购买";
            }
            return text;   
        },
        // 确认账号 - 提示文案
        confirmTips() {
            let tispText = this.tispText;
            let strList = tispText.split("##");
            var tipsTexts = "";
            strList.forEach((item) => {
                if(item.indexOf("href=") > -1) {
                    let list = item.split("href=");
                    item=`<span class="blue-text" data-url="${list[1] || ""}">${list[0] || ""}</span>`;
                }
                tipsTexts= tipsTexts + item;
            });
            return xss(tipsTexts); // { whiteList: {span: ["class"]}}
        }
    },

    watch:{
        "valObj.tel.val": {
            deep:true,
            handler() { 
                let { val = "" } = this.valObj.tel;
                val = val.replace(this.reg, "");
                val = val.replace(/[^0-9]/ig,"");
                if(val.length > 11) {
                    val = val.slice(0, 11);
                }
                
                this.valObj.tel.val = val;
            }
        },
        "valObj.verifyCode.val": {
            deep:true,
            handler() { 
                let { val = "" } = this.valObj.verifyCode;
                val = val.replace(this.reg, "");
                val = val.replace(/[^0-9]/ig,"");
                if(val.length > 6) {
                    val = val.slice(0, 6);
                }
                this.valObj.verifyCode.val = val;
            }
        },
        "valObj.qq.val": {
            deep:true,
            handler() { 
                let { val = "" } = this.valObj.qq;
                val = val.replace(this.reg, "");
                val = val.replace(/[^0-9]/ig,"").replace(/^0/,"");
                if(val.length > 10) {
                    val = val.slice(0, 10);
                }
                this.valObj.qq.val = val;
            }
        },
        "valObj.qq.confirmVal": {
            deep:true,
            handler() { 
                let { confirmVal = "" } = this.valObj.qq;
                confirmVal = confirmVal.replace(this.reg, "");
                confirmVal = confirmVal.replace(/[^0-9]/ig,"").replace(/^0/,"");
                if(confirmVal.length > 10) {
                    confirmVal = confirmVal.slice(0, 10);
                }
                this.valObj.qq.confirmVal = confirmVal;
            }
        }
    },

    async created() {
        let _this = this;
        // 腾讯云
        // window.TCaptchaCallBack = function(res){
        //     let {code, data, massage} = res;
        //     // Console.log("TCaptchaCallBack::: ", res);
        //     if(code != 200){
        //         Console.log(massage);
        //         return false;
        //     }
        //     _this.tCaptchaConfig = data || {};
        // };
        // await getVerifyConfig({callback: "TCaptchaCallBack"}).then(({data: res})=>{
        //     if(typeof res == "string" && res.indexOf("TCaptchaCallBack") > -1){
        //         const configFn = new Function(res);
        //         configFn();
        //     }
        // }).catch((err) => {
        //     Console.warn("获取验证码接口异常:", err);
        //     // this.myToast({text:"操作频繁，请稍后再试", time:1});
        // });
        await getGeetestInit().then((res)=>{
            let { code, data, message } = res.data;
            if (code !== 200) {
                this.myToast({text:message, time:1});
            }
            let fn = (captchaObj) => {
                captchaObj.onReady(() => {
                    _this.captchaObj = captchaObj;
                }).onSuccess(() => {
                    _this.captchaObj = captchaObj;
                    _this.showGeetest();
                }).onError(() => {
                    captchaObj.reset();
                    _this.isClickBtn = true;// 防止重复点击
                    _this.isClickTimes = 0;
                    _this.valObj.verifyCode.isClick = false;
                }).onClose(() => {
                    captchaObj.reset();
                    _this.isClickBtn = true;// 防止重复点击
                    _this.isClickTimes = 0;
                    _this.valObj.verifyCode.isClick = false;
                });  
            };
            if (data.gt) {
                let send = {
                    gt: data.gt,
                    challenge: data.challenge,
                    width: "100%",
                    product: "bind",
                    offline: !data.success,
                    new_captcha: true,
                    api_server:"api.geevisit.com"
                };
                window.initGeetest(send, fn);
            }
        }).catch(err => {
            this.myToast({text:"getGeetestInit:"+err.message || "网络错误", time:1});
        });
    },

    beforeMount() {
        this.setUserBindType();
    },

    async mounted() {
        // 获取用户绑定的信息
        this.compGetAccount(()=>{
            this.setUserBindType(this.userBindAccount);
        }); 
    },

    methods: {
        // 设置弹窗type的值, 控制显示样式 data: 用户绑定号码数据对象
        setUserBindType(data){
            let userData = data || this.userData;
            let {
                assign_account_type = 0, // 0: 仅手机号 1:手机号qq号都有 2:仅qq号
                charge_type = 0, // 0: 非直冲 1: 直充
                phone_account = "", // 手机号账号
                qq_account = "" // qq账号
            } = userData;
            // type 1: 绑定手机号 2: 绑定qq号 3.绑定手机和QQ号 4:变更账号(手机号) 5:变更账号(QQ号) 6:确认账号(手机) 7:确认账号(qq/手机号)
            let type = 3;
            if(assign_account_type == 0){
                type = phone_account ? 6 : 1;
            } else if(assign_account_type == 1) {
                if(phone_account && qq_account){
                    type = 7;
                } else if(!phone_account && !qq_account) {
                    type = 3;
                } else if(!phone_account){
                    type = 1;
                } else if(!qq_account){
                    type = 2;
                }
            } else if(assign_account_type == 2){
                type = qq_account ? 8 : 2;
            } else { 
                // 数据异常的情况
                type = 3;
            }
            // 非直充的情况 S
            if(charge_type == 0){
                type = phone_account ? 6 : 1;
            }
            // 非直充的情况 E
            this.type = type;
            
            // 在beforeMount初始化父级传递的用户信息使用
            if(!data){
                this.userBindAccount = {...this.userData};
            }
        },

        // 点击关闭弹窗
        clickCloseBtn() {
            this.$emit("closeBindAccountPopup", this.userBindAccount);
        },

        // 点击获取验证按钮
        clickCodeBtn() {
            let tel = this.valObj.tel;
            let isPhone = tel.reg.test(tel.val);
            if(!this.isClickBtn){
                this.myToast({text:"操作频繁，请稍后再试", time:1});
                return false;
            }
            if(isPhone) {
                this.showTencentCaptcha();
            } else {
                this.myToast({text:"请输入正确的手机号", time:1});
            }
        },

        // 点击手机号变更
        changePhone() {
            this.valObj.tel.val = "";
            this.valObj.verifyCode.val = "";
            this.type = 4;
            clearInterval(this.countDownTime);
            this.isClickBtn = true;// 防止重复点击
            this.isClickTimes = 0;
        },

        // 点击QQ号变更
        changeQQ() {
            this.valObj.qq.val = "";
            this.valObj.qq.confirmVal = "";
            this.type = 5;
        },

        // 显示验证码（极验）
        async showGeetest(){
            this.valObj.verifyCode.isClick = true; // 点击过获取验证
            this.isClickBtn = false;// 防止重复点击
            this.isClickTimes = 60;
            clearTimeout(this.countDownTime);
            this.countDownTime = null;
            // this.captchaObj.getValidate() 如果没有校验成功返回字符串undefined
            let geetestData = this.captchaObj.getValidate ? this.captchaObj.getValidate() : undefined;
            // 调起极验弹窗
            if (geetestData == undefined) {
                this.captchaObj.verify && this.captchaObj.verify();
                return false;
            }
            await postCheckGt({
                challenge: geetestData.geetest_challenge,
                validate: geetestData.geetest_validate,
                seccode: geetestData.geetest_seccode,
                gt_server_status: geetestData.gt_server_status,
            }).then(({data:res}) => {
                let { code, message } = res;
                if (code !== 200) {
                    this.isClickBtn = true;// 防止重复点击
                    this.isClickTimes = 0;
                    this.valObj.verifyCode.isClick = false;
                    this.myToast({text: message, time:1});
                    return false;
                }
                postGetSMSCodeGeetest({
                    phone: this.valObj.tel.val,
                    geetest_challenge: geetestData.geetest_challenge,
                    smscode_type: 12 // 极验付费绑定手机号固定写法
                }).then(res => {
                    this.captchaObj.reset();
                    this.isClickBtn = false;// 防止重复点击
                    this.isClickTimes = 60;
                    let { code, message } = res.data;
                    if (code != 200) {
                        this.myToast({text: message, time:1});
                        this.isClickBtn = true;// 防止重复点击
                        this.isClickTimes = 0;
                        this.valObj.verifyCode.isClick = false;
                        return false;
                    }
                    this.myToast({text: "验证码已发送，请注意查收", time:1});
                    this.countDown(); // 开始倒计时
                }).catch(err => {
                    this.myToast({text: "postGetSMSCodeGeetest:"+err.message || "网络错误", time:1});
                    this.isClickBtn = true;// 防止重复点击
                    this.isClickTimes = 0;
                    this.valObj.verifyCode.isClick = false;
                });
                
            }).catch(err => {
                this.myToast({text:"postCheckGt:"+err.message || "网络错误", time:1});
                this.isClickBtn = true;// 防止重复点击
                this.isClickTimes = 0;
                this.valObj.verifyCode.isClick = false;
            });
        },

        // 显示滑动验证码（腾讯）
        showTencentCaptcha() {
            this.showGeetest(); // 暂时弃用腾讯验证修改为极验
            return false;
            // if(!this.tCaptchaConfig){
            //     this.myToast({text:"服务异常，请稍后再试", time:1});
            // }
            // let tCaptchaConfig = this.tCaptchaConfig || {};
            // let {app_id} = tCaptchaConfig;
            // const _this = this;
            // let TencentCaptcha = window.TencentCaptcha || function () {};
            // const pageCaptcha = new TencentCaptcha(app_id, (res) => {
            //     res = res || {};
            //     _this.ticket = res.ticket || "";
            //     _this.random = res.randstr || "";

            //     this.isClickBtn = false;// 防止重复点击
            //     this.isClickTimes = 60;
            //     clearTimeout(this.countDownTime);
            //     this.countDownTime = null;
            //     this.valObj.verifyCode.isClick = true; // 点击过获取验证
            //     _this.getSmsCode(); // 调起获取短信验证码
            // });
            // pageCaptcha.show(); // 显示验证码
        },

        // 倒计时模块
        countDown() {
            this.countDownTime = setInterval(()=>{
                const {isClickTimes} = this;
                if(isClickTimes-1 <= 0){
                    clearInterval(this.countDownTime);
                    this.countDownTime = null;
                    this.isClickBtn = true;
                    this.isClickTimes = 0;
                    return false;
                }
                this.isClickTimes = this.isClickTimes-1;
            }, 1000);
        },

        // 获取短信验证码
        // getSmsCode(callback) {
        //     if(!callback || typeof callback !="function"){
        //         callback = () => {};
        //     }
        //     const {valObj, ticket, random} = this;
        //     let { tel } = valObj;
        //     if (!tel.reg.test(tel.val)) {
        //         return false;
        //     }

        //     postSmsSendCode({
        //         phone: tel.val, 
        //         verify_provider: "tencent", 
        //         ticket, 
        //         random 
        //     }).then(({data:res}) => {
        //         let code = res.code || "";
        //         this.smsResCode = code; // 短信接口的code
        //         this.ticket = "";
        //         this.random = "";
        //         if(code != 200){
        //             this.isClickBtn = true; // 防止重复点击
        //             this.isClickTimes = 0;
        //             if(code == 15001){ // 进行显示滑动验证码
        //                 this.showTencentCaptcha();
        //             }else{ // 错误提示
        //                 this.myToast({text: res.message || "操作频繁，请稍后再试", time:1});
        //             }
        //         }else{
        //             this.myToast({text:"验证码已发送，请注意查收", time:1});
        //             this.countDown();
        //         }
        //     }).catch(() => {
        //         this.ticket = "";
        //         this.random = "";
        //         this.isClickBtn = true;// 防止重复点击
        //         this.isClickTimes = 0;
        //         this.myToast({text:"服务异常，请稍后再试", time:1});
        //     });
        // },

        // 点击确认按钮
        clickConfirmBtn() {
            const { type } = this;
            // 绑定手机号或者换绑手机号
            if(type==1 || type==4){
                this.bindPhone();
                return false;
            }
            if(type==2 || type ==5){
                this.bindQQ();
                return false;
            }
            // qq & 手机号都需要绑定
            if(type==3) {
                this.bindAll();
                return false;
            }
            // 确认账号
            if(type==6 || type==7 || type==8) {
                this.$emit("closeBindAccountPopup", this.userBindAccount);
                this.$emit("opencallback", this.userBindAccount);
            }
        },

        // 手机号: 绑定账号 & 变更账号 
        bindPhone() {
            // 防止重复点击提交按钮
            if(!this.isClickConfirmBtn) {
                return false;
            }
            // 校验输入的结果
            let checkResult = this.checkInputValue("phone");
            if(!checkResult) {
                return false;
            }

            this.startBindRequest({
                type: "phone", 
                cb: () => { 
                    // 更新绑定账号
                    this.setUserBindType(this.userBindAccount);
                    Console.warn("绑定成功-phone");
                }
            });
        },

        // QQ号: 绑定账号 & 变更账号
        bindQQ() {
            // 防止重复点击提交按钮
            if(!this.isClickConfirmBtn) {
                return false;
            }
            // 校验输入的结果
            let checkResult = this.checkInputValue("qq");
            if(!checkResult) {
                return false;
            }

            this.startBindRequest({
                type: "qq", 
                cb: () => { 
                    // 更新绑定账号
                    this.setUserBindType(this.userBindAccount);
                    Console.warn("绑定成功-qq");
                }
            });
        },

        // qq & 手机号都需要绑定
        bindAll() {
            // 防止重复点击提交按钮
            if(!this.isClickConfirmBtn) {
                return false;
            }
            // 校验输入的结果
            let checkResult = this.checkInputValue("all");
            if(!checkResult) {
                return false;
            }
            this.startBindRequest({
                type: "all", 
                cb: () => { 
                    // 更新绑定账号
                    this.setUserBindType(this.userBindAccount);
                    Console.warn("绑定成功-all");
                }
            });
        },

        /**
         * @name checkInputValue 根据弹窗类型进行输入框值校验
         * @param type {string}  phone: 手机号账号绑定和切换 qq: qq号账号绑定和切换 all: 手机和qq号绑定
         * @returns result {Boolean} 返回当前状态的校验结果
         * **/
        checkInputValue(type = "phone") { 
            let result = true;
            // 校验手机号相关输入
            let {tel, verifyCode } = this.valObj;
            let isPhone = tel.reg.test(tel.val);
            let isVerifyCode = verifyCode.reg.test(verifyCode.val);
            if(!isPhone){
                if(type == "phone" || type == "all") {
                    result = false;
                    this.myToast({text:"请输入正确的手机号", time:1});
                }
                if(type == "phone") {
                    return result;
                }
            }
            if(!isVerifyCode){
                if(type == "phone" || type == "all") {
                    result = false;
                    let len = verifyCode.val.length;
                    this.myToast({text:len > 0 && len < 6 ? "手机验证码错误" : "请输入验证码", time:1});
                }
                if(type == "phone") {
                    return result;
                }
            }
            if(!verifyCode.isClick){
                if(type == "phone" || type == "all") {
                    result = false;
                    this.myToast({text:"请先获取验证码", time:1});
                }
                if(type == "phone") {
                    return result;
                }
            }

            // 校验QQ号相关输入
            const qq = this.valObj.qq;
            const {val, confirmVal} = qq;
            let isqq = qq.reg.test(val);
            let maxqq = 3750000000; // 服务和业务方要求qq号不能超过这个值
            if(!val || (type=="qq" && !confirmVal)){
                if(type == "qq" || type == "all") {
                    result = false;
                    this.myToast({text:"请输入正确的QQ号", time:1});
                }
                if(type == "qq") {
                    return result;
                }
            }
            if(!isqq || Number(val) > maxqq) {
                if(type == "qq" || type == "all") {
                    result = false;
                    this.myToast({text:"请输入正确的QQ号", time:1});
                }
                if(type == "qq") {
                    return result;
                }
            }
            if(val != confirmVal) {
                if(type == "qq") {
                    result = false;
                    this.myToast({text:"账号不一致", time:1});
                    return result;
                }
            }

            if(type == "all") {
                return result;
            }
            return true;
        },

        /**
         * @name startBindRequest 发起绑定通用联合会员账号请求
         * @param type {string}  phone: 手机号账号绑定和切换 qq: qq号账号绑定和切换 all: 手机和qq号绑定
         * @returns 无
         * 注: 保证导入 postBindAccount 函数
         * **/ 
        startBindRequest({type = "phone", cb = () => {}} = {}) {
            let sendData = {};
            const {tel, verifyCode } = this.valObj;
            const qq = this.valObj.qq;
            const {val, confirmVal} = qq;
            
            if(type == "phone") {
                sendData  = {
                    assign_account_type : 0, // 0: 变更手机&绑定手机号
                    code: verifyCode.val , 
                    phone_account: tel.val
                };
            }
            if(type == "qq") {
                sendData  = {
                    assign_account_type : 2, // 2: 变更QQ&绑定QQ号
                    qq_account: val , 
                    confirm_qq_account: confirmVal
                };
            }
            if(type=="all") {
                sendData = {
                    assign_account_type : 1, // 1: 混搭绑定
                    code: verifyCode.val , 
                    phone_account: tel.val,
                    qq_account: val
                };
            }
            if(!cb || typeof cb != "function"){
                cb = () => {};
            }
            // 防止重复点击提交按钮
            if(!this.isClickConfirmBtn) {
                return false;
            }
            this.isClickConfirmBtn = false;
            sendData.activity_name = tools.urlValue().activity_name || "link_vip_module_charge";
            sendData.award_name = tools.urlValue().award_name || "send_5_assign";
            let that = this;
            gs("/v1/aegis/api/web/challenge?callback=callback").then(function (sign) {
                sendData.answer = sign;
                postBindAccount(sendData).then(({data: res}) => {
                    const {code, message} = res;
                    // Console.log("startBindRequest:::", "type::", type, "res::", res);
                    if(code != 200){
                        that.isClickConfirmBtn = true;
                        that.myToast({text: message, time:1});
                        return false;
                    }
                    that.compGetAccount(() => {
                        that.isClickConfirmBtn = true; // 可以点击确认按钮
                        cb(); // 开始执行回调
                    });
                    that.valObj.tel.val = "";
                    that.valObj.verifyCode.val = "";
                    that.valObj.verifyCode.isClick = false;
                    that.valObj.qq.val = "";
                    that.valObj.qq.confirmVal = "";
                    const { type } = that;
                    if(type==4 || type ==5){
                        that.myToast({text: "变更成功", time:1});
                    } else {
                        that.myToast({text: "绑定成功", time:1});
                    }
                }).catch(() => {
                    that.isClickConfirmBtn = true;
                    that.myToast({text:"系统异常, 请稍后再试", time:1});
                });
            });
        },

        // 当前组件调用获取用户绑定的账号信息
        async compGetAccount(cb = () => {}) {
            if(!cb || typeof cb != "function"){
                cb = () => {};
            }
            await getAccount().then(({data: res}) => {
                let {code, data, message} = res;
                if(code !=200){
                    Console.warn("获取绑定账号::", message);
                }else{
                    data = data || {};
                    this.userBindAccount.phone_account = data.phone_account || "";
                    this.userBindAccount.qq_account = data.qq_account || "";   
                }
                cb();
            }).catch(err => {
                Console.warn("获取绑定账号::", err);
                cb();
            });
        },

        // 输入框ios 兼容
        onFocus(e) {
            // 解决ios 11.3 下 input 触发不灵敏的问题(非第一次点击 键盘不能立即掉起 需要多次点击或者长按)
            e.target.focus();
        },

        onBlur() {
            let result;
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
                result = "ios";
            } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
                result = "android";
            }

            if (result == "ios") {
                setTimeout(function () {
                    var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }, 100);
            }
        },

        // 自定义弹窗
        myToast ({ text="", time=1, success = () => {} }){
            // const gvalkkmh = window.__gvalkkmh || {ua:{}};
            // if (gvalkkmh.ua.kkmh) {
            //     return show_tips({text, time: 0, style: 1, type: 2});
            // }
            let isEle = document.getElementById("toast");
            if(isEle){ //说明上一个提示尚未完成
                return false;
            }
            time = time === 1 ? 3000 : 5000;
            let el = document.createElement("div");
            let textLen = text.length || 0;
            el.setAttribute("id","toast");
            el.setAttribute("style",`${textLen <= 16 ? "white-space: nowrap;" : ""}`);
            el.innerHTML = text ; // `<div>${text}</div>`;
            document.body.appendChild(el);
            el.className=`fadeIn ${textLen > 16 ? "max-toast" : ""}`;
            el.classList.add("fadeIn");
            let newTime = setTimeout(() => {
                clearTimeout(newTime);
                el.className=`fadeOut ${textLen > 16 ? "max-toast" : ""}`;
                el.addEventListener("animationend", () => {
                    document.body.removeChild(el);
                    success && success({code:200, data:{text, time}, message:"执行完成"});
                });
            },time);
        },

        // 判断是否链接
        isUrl(val){
            /*eslint no-useless-escape:0*/
            let reg = /^(http|https):\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\’:+!]*([^<>\"\"])*$/;
            if(typeof val == "string" ){
                return reg.test(val);
            }else{
                return false;
            }
        },

        // 点击弹窗提示文案
        clickTipsText(event){
            event = event || {};
            const gvalkkmh = window.__gvalkkmh || {ua:{}};
            let ele = event.target || {};
            if(ele.className != "blue-text"){
                return false;
            }
            if(!this.isUrl(ele.dataset.url)){
                return false;
            }
            if(gvalkkmh.ua.kkmh){
                switch_page({
                    action_type: 18,
                    extra_params: {
                        target_web_url: ele.dataset.url
                    }
                });
            } else {
                window.location.href = ele.dataset.url;
            }

            // className dataset
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/sass/vws.scss'; //NOSONAR
.bind-account-popup-warp{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    button{
        margin: 0;
        padding: 0;
        outline: none;
        border: transparent;
        background-color: transparent;
    }
    input{  
        margin: 0;
        padding: 0;
        background: none;  
        outline: none;  
        border: none;
    }
    input::placeholder{
        font-size: vws(30px);
        font-family: PingFang SC, sans-serif, serif;
        font-weight: 400;
        color: #999999;
    }
    .content-warp{
        position: relative;
        box-sizing: border-box;
        width: vws(560px);
        padding: vws(52px) vws(42px) vws(30px);
        background: #FFFFFF;
        border-radius: vws(24px);
        .middle-warp{
            margin: 0 auto;
            width: vws(474px);
            height: auto;
        }
        // 输入框部分
        .input-warp{
            padding-bottom: vws(22px);
        }
        input{
            display: block;
            padding: vws(22px) vws(30px);
            box-sizing: border-box;
            height: vws(84px);
            line-height: vws(40px);
            background: #FFFFFF;
            border: vws(2px) solid #999999;
            border-radius: vws(20px);
            font-size: vws(30px);
            font-family: PingFang SC, serif, sans-serif;
        }
        .label-name{
            padding-bottom: vws(12px);
            font-size: vws(28px);
            font-family: PingFang SC, serif, sans-serif;
            font-weight: 500;
            color: #4D4D4D;
        }

        .phone, .phone input{
            display: block;
            width: 100%;
        }
        .captcha-code{
            display: flex;
            align-items: center;
            input{
                width: vws(260px);
            }
            button{
                margin-left: vws(14px);
                width: vws(200px);
                height: vws(84px);
                background: #FCE04E;
                border-radius: vws(20px);
                font-size: vws(30px);
                font-family: PingFang SC, sans-serif, serif;
                font-weight: 500;
                color: #4A2525;
                text-align: center;
                line-height: vws(84px);
                &.disabled {
                    background: #eee;
                    color: #aaa;
                }
            }
        }

        .bind-qq-pd{
            padding-top: vws(10px);
        }
        .bind-qq{
            input{
                width: 100%;
            }
        }

        // 确认账号部分
        .account-warp{
            padding: 0 vws(24px);
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            .text{
                flex: 1;
                font-size: vws(30px);
                font-family: PingFang SC, sans-serif, serif;
                font-weight: 500;
                color: #FF751A;
                text-align: center;
                display: flex;
                span{
                    width: vws(130px);
                    font-weight: 500;
                    color: #333333;
                    text-align: right;
                }
            }
            button{
                padding: vws(8px) 0;
                font-size: vws(30px);
                font-family: PingFang SC, sans-serif, serif;
                font-weight: 400;
                text-decoration: underline;
                color: #FF751A;
            }
        }
        .account-qq, .account-phone-pd{
            padding: vws(6px) vws(24px) 0 vws(24px);
        }
    }
    // 提示文案
    .tips-text-warp{
        padding-bottom: vws(30px);
        line-height: vws(24px);
        font-size: vws(22px);
        font-family: PingFang SC, sans-serif, serif;
        font-weight: 400;
        color: #999999;
        text-align: center;
    }
    .tips-text-warp.tips-text-warp-pd{
        padding: 0 vws(24px) vws(30px);
        text-align: justify;
        line-height: vws(34px);
    }
    .submit-warp{
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: vws(474px);
        height: vws(84px);
        button{
            width: 100%;
            height: 100%;
            font-size: vws(30px);
            font-family: PingFang SC, serif, sans-serif;
            font-weight: 500;
            color: #4A2525;
            text-align: center;
            line-height: vws(84px);
            background: #FCE04E;
            border-radius: vws(42px);
        }
    }

    // 头部标题
    .header{
        display: block;
        padding-bottom: vws(28px);
        h5 {
            height: vws(40px);
            line-height: vws(40px);
            font-size: vws(40px);
            font-family: PingFang SC, sans-serif, serif;
            font-weight: 500;
            color: #333333;
            text-align: center;
        }
    }

    // 底部关闭标题
    .footer{
        box-sizing: content-box;
        position: absolute;
        left: 0;
        right: 0;
        bottom: vws(-108px);
        margin: 0 auto;
        padding: vws(10px);
        width: vws(58px);
        height: vws(58px);
        .close-btn{
            display: block;
            width: 100%;
            height: 100%;
            background-image: url('../img/close-btn.png');
            background-size: cover;
            border-radius: 50%;
        }
    }

    .blue-text{
        color: #1d72f0;
    }
}


// 自定义toast提示组件样式 S
@keyframes fadeIn {
    0%    {opacity: 0}
    100%  {opacity: 1}
}
@keyframes fadeOut {
    0%    {opacity: 1}
    100%  {opacity: 0}
}
#toast{
    max-width: 75%;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    font-size: 14px;
    line-height: 1;
    padding:10px;
    border-radius: 3px;
    position: fixed;
    left: 50%;
    bottom: 10%;
    transform: translate(-50%,-50%);
    z-index: 999999;
    text-align: justify;
}
#toast.hide{
    display: none;
}
#toast.fadeOut{
    animation: fadeOut .5s;
}
#toast.fadeIn{
    animation:fadeIn .5s;
}
#toast.max-toast{
    width: 70%;
}
</style>


// WEBPACK FOOTER //
// src/pages/native/pay/vip/link_vip_multiple/comp/BindAccountPopup.vue